/**
 * header.countWhere
 *
 * Counts items in a sub-array where a field meets a condition, and writes
 * the result to a (possibly dotted) targetField on the header. Returns 0
 * when no items match so the field is always a number.
 *
 * Config shape:
 * {
 *     logicType: 'calcFields',
 *     operationType: 'header.countWhere',
 *     subEntity: 'lines',
 *     where: { field: 'supplierId', operator: 'exists' },
 *     targetField: 'totals.sourcedQuantity'
 * }
 *
 * Supported operators:
 *   exists     — field is not null / undefined / ''
 *   not_exists — field is null, undefined, or ''
 *   gt         — field > value
 *   gte        — field >= value
 *   lt         — field < value
 *   lte        — field <= value
 *   eq         — field === value
 */
const headerCountWhere = (data, operation) => {
    const { subEntity, where, targetField, sumField } = operation

    if (!subEntity || !where || !targetField) return data

    const items = data[subEntity]
    const matched = Array.isArray(items) ? items.filter(item => matchesWhere(item, where)) : []

    const result = sumField
        ? parseFloat(matched.reduce((acc, item) => acc + (typeof item[sumField] === 'number' ? item[sumField] : 0), 0).toFixed(2))
        : matched.length

    return setDotPath({ ...data }, targetField, result)
}

const matchesWhere = (item, where) => {
    const { field, operator, value } = where
    const v = item?.[field]

    switch (operator) {
        case 'exists':     return v !== null && v !== undefined && v !== ''
        case 'not_exists': return v === null || v === undefined || v === ''
        case 'gt':         return typeof v === 'number' && v > value
        case 'gte':        return typeof v === 'number' && v >= value
        case 'lt':         return typeof v === 'number' && v < value
        case 'lte':        return typeof v === 'number' && v <= value
        case 'eq':         return v === value
        default:           return false
    }
}

const setDotPath = (obj, path, value) => {
    if (!path.includes('.')) {
        obj[path] = value
        return obj
    }
    const dot = path.indexOf('.')
    const parent = path.substring(0, dot)
    const child = path.substring(dot + 1)
    obj[parent] = { ...(obj[parent] || {}), [child]: value }
    return obj
}

export default headerCountWhere
